// 模块
export default {
	home: {
		name: "首頁"
	},
	page_out_trade_no: "商戶單號",
	page_merchant_sub_order_no: "商戶子訂單號",
	_model_has_no_obj: "該模型暫無OBJ模型",
	_model_has_no_gaussian: "該模型無高斯模型",
	submit_modeling_model_file_not_ready: "模型文件暫未準備完成，請稍後重試或聯繫客服處理",
	finance_package_order_reverse: "套餐一口價紅衝",
	finance_shop_red_reversal: "門店紅衝",
	finance_dealer_red_reversal: "經銷商紅衝"
};
